export default __webpack_public_path__ + "static/media/gameScreen.c9c58bec.png";